import type { StateResponse } from '../domain';

type Group = 'ground' | 'middle_sun' | 'middle_shade' | 'top_sun' | 'top_shade';

const GROUP_LABEL: Record<Group, string> = {
  ground: 'Ground',
  middle_sun: 'Middle · sun',
  middle_shade: 'Middle · shade',
  top_sun: 'Top · sun',
  top_shade: 'Top · shade',
};

export function GroupRow({
  group,
  state,
}: {
  group: Group;
  state: StateResponse['groups'][Group];
}) {
  return (
    <div className="group-row">
      <span>{GROUP_LABEL[group]}</span>
      <span className={`tag ${state.state}`}>{state.state}</span>
      {state.active_override && (
        <span className="tag heat" style={{ marginLeft: 8 }}>override: {state.active_override.kind}</span>
      )}
    </div>
  );
}
